module.exports = __webpack_public_path__ + "static/media/success-logo.f1faf0c1.png";